const DEFAULT_API_ROOT = "https://api.theamplesamples.com";

const stripTrailingSlash = (url) => url.replace(/\/+$/, "");

export const API_ROOT = stripTrailingSlash(
    process.env.REACT_APP_API_URL || DEFAULT_API_ROOT
);

export const API_V1_URL = `${API_ROOT}/api/v1/`;

export const API_V2_URL = `${API_ROOT}/api/v2`;

export const MEMBERSHIP_API_URL =
    process.env.REACT_APP_MEMBERSHIP_API_URL || `${API_ROOT}/api`;
